module.exports = __webpack_public_path__ + "Lato-BoldItalic.7b48d663230528ecb6db.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-BoldItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-BoldItalic.eot
// module chunks = styles